const getStatusColor = (status: string) => {
  const items = {
    Pending: {
      text: 'red500',
      bg: 'red50',
    },
    Closed: {
      text: 'red500',
      bg: 'red50',
    },
    Delivered: {
      text: 'yellow500',
      bg: 'yellow100',
    },
    'Not Started': {
      text: 'yellow500',
      bg: 'yellow100',
    },
    Completed: {
      text: 'success100',
      bg: 'success50',
    },
    Cancelled: {
      text: 'red500',
      bg: 'red50',
    },
    'On going': {
      text: 'primary',
      bg: 'primaryLight',
    },
    'On Going': {
      text: 'primary',
      bg: 'primaryLight',
    },

    Win: {
      text: 'sucess100',
      bg: 'success50',
    },
    Review: {
      text: 'sucess100',
      bg: 'success50',
    },
    Loss: {
      text: 'red500',
      bg: 'red50',
    },
    Lose: {
      text: 'red500',
      bg: 'red50',
    },
    Reported: {
      text: 'white',
      bg: 'text',
    },
    Solved: {
      text: 'primary',
      bg: 'primaryLight',
    },
    Resolved: {
      text: 'primary',
      bg: 'primaryLight',
    },
    'Match Won': {
      text: 'success100',
      bg: 'success50',
    },
    'Match Lost': {
      text: 'red500',
      bg: 'red50',
    },
    Joined: {
      text: 'primary',
      bg: 'primaryLight',
    },
    Refund: {
      text: 'success100',
      bg: 'success50',
    },
    Cheated: {
      text: 'white',
      bg: 'text',
    },
    Other: { text: 'white', bg: 'text' },
  }
  return items[status] || items['Other']
}

const getUser = () => {
  const user = sessionStorage.getItem('tournaop-user')
  return user ? JSON.parse(user) : null
}

const removeUser = () => {
  return sessionStorage.removeItem('tournaop-user')
}

const saveUser = (data: any) => {
  return sessionStorage.setItem('tournaop-user', JSON.stringify(data))
}

const toCamelCase = (str: string) => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase(),
    )
    .replace(/\s+/g, '')
}

const COLORS = [
  '#007bff',
  '#6f42c1',
  '#e83e8c',
  '#fd7e14',
  '#20c997',
  '#17a2b8',
]

const getDynamicColor = (input: string) => {
  let hash = 0
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash)
  }
  const index = Math.abs(hash) % COLORS.length
  return COLORS[index]
}

export default {
  getStatusColor,
  getUser,
  removeUser,
  saveUser,
  toCamelCase,
  getDynamicColor,
}
